// Fetch a presigned URL with intent=download (so the backend records the
// download event) and trigger a browser download without proxying bytes.
export async function downloadProjectFile(file: { id: string; originalName: string }): Promise<void> {
  const token = localStorage.getItem('geodraft_token') || '';
  try {
    const res = await fetch(`/api/files/${file.id}/url?intent=download`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({} as { error?: string }));
      if (body.error) window.alert(body.error);
      return;
    }
    const { url } = await res.json() as { url: string };
    const a = document.createElement('a');
    a.href = url;
    a.download = file.originalName;
    a.click();
  } catch { /* download failed — leave the UI as-is */ }
}
